import { createSelector } from '@reduxjs/toolkit';
import { storeSelector } from '../StoreSelector';

const videoSource = createSelector(storeSelector, (state) => state.video.videoSource);

export default {
  videoSource
};
